import { StringUtil } from "@eres/core";
import { ProfilePicApi } from "@10x/dubai-rest-api";
import { getParticipantID } from "@10x/sso";
import { getAppServices } from "@10x/coreapp/index";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { profile } from "@eres/ssoapi/api";

export function getRootPath( path: string ) {
	return getPathFragment( path );
}

export function getPathFragment( path: string, index = 0 ): string | null {
	let fragments = path.split( "/" );
	if ( fragments.length >= index )
		return fragments[ index + 1 ];
	return null;
}

export function getParentPath( fullPath: string, fragment: string ): string | null {
	let fragments = fullPath.split( "/" );
	let segments: string[] = [];
	for ( const f of fragments ) {
		if ( StringUtil.isEmptyStringOrNull( f ) ) continue;
		if ( f === fragment ) {
			break;
		} else {
			segments.push( f );
		}
	}
	if ( segments.length >= 0 )
		return "/" + segments.join( "/" );
	return "/";
}


export function getChildRoute( parent: string ): string | null {
	const currentPath = getAppServices().storeService.getStore().getState().router.location.pathname;
	const fragments = currentPath.split( "/" );
	let x = 0;
	let pIx = -1;
	for ( const f of fragments ) {
		x += 1;
		if ( StringUtil.isEmptyStringOrNull( f ) ) continue;
		if ( f === parent ) {
			pIx = x;
			break;
		}
	}
	if ( pIx !== -1 && fragments.length > pIx ) {
		return fragments[ pIx ];
	}
	return null;
}

export function getParentFullPath( currentPath: string, parent: string ) {
	const fragments = currentPath.split( "/" );
	let path = "";
	for ( const f of fragments ) {
		if ( StringUtil.isEmptyStringOrNull( f ) ) continue;
		path = path + "/" + f;
		if ( f === parent ) {
			break;
		}
	}
	return path;
}


export function getProfilePicUrl( cacheId?: number ) {
	let participantID = getParticipantID();
	if ( participantID ) {
		return ProfilePicApi.getProfilePicUrl( participantID ) + ( cacheId ? ( "?cacheId=" + cacheId ) : "" );
	} else {
		const ssoProfile = SSOProfile.getProfile();
		if ( ssoProfile ) {
			return profile.getProfilePicUri();
		}
		return ProfilePicApi.getProfilePicUrl( "no_profile" );
	}
}

export function getDefaultProfilePicUrl() {
	return ProfilePicApi.getProfilePicUrl( "no_profile" );
}

export function appendPath( parent: string, newSegment: string ) {
	if ( newSegment.startsWith( "/" ) ) {
		if ( parent.endsWith( "/" ) )
			parent = parent.substr( 0, parent.lastIndexOf( "/" ) );
	}
	return parent + newSegment;
}
